var _rect, _circle, _circle2, _g, _rect2, _line, _line2, _circle3, _circle4, _circle5, _rect3, _rect4, _rect5, _circle6, _circle7, _rect6, _rect7, _circle8, _circle9, _circle10, _circle11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    transform: "translate(0 0.5)",
    fill: "#F7F7F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.5,
    r: 80,
    fill: "#EB4D3D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3294_17320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 160,
    height: 161
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.5,
    r: 80,
    fill: "#5222D0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3294_17320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18 183.5L157.803 25.5H160.159L100.205 183.5H-18Z",
    fill: "#F7F7F7"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 51,
    width: 141,
    height: 90,
    rx: 11.5,
    fill: "#F7F7F7",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 53.5,
    y1: 67.5,
    x2: 53.5,
    y2: 141.5,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 67,
    x2: 167,
    y2: 67,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 59.5,
    r: 2.5,
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 59.5,
    r: 2.5,
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 59.5,
    r: 2.5,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 115,
    width: 115,
    height: 42,
    rx: 7.5,
    fill: "#F7F7F7",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 139,
    width: 85,
    height: 8,
    rx: 4,
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 125,
    width: 85,
    height: 8,
    rx: 4,
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 129,
    r: 4,
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 143,
    r: 4,
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 82,
    width: 115,
    height: 28,
    rx: 7.5,
    fill: "#F7F7F7",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 92,
    width: 85,
    height: 8,
    rx: 4,
    stroke: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 44,
    r: 2,
    stroke: "#EB4D3D"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 21,
    r: 2,
    stroke: "#EB4D3D"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 164,
    r: 2,
    stroke: "#EB4D3D"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 96,
    r: 4,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLogo);
export default __webpack_public_path__ + "static/media/error_logo.10ab0e9daa552d4242cb84d29757d125.svg";
export { ForwardRef as ReactComponent };